// Certificate images array
export const certificateImages = [];
for (let i = 1; i <= 14; i++) {
  certificateImages.push(require(`../../assets/certificate_${i}1.webp`));
}
